export default __webpack_public_path__ + "static/media/logo.ed30723b.png";